
import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { logoImages } from '../../utils/images';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navItems = [
    { name: 'HOME', path: '/' },
    { name: 'ABOUT US', path: '/about' },
    { name: 'OUR SERVICES', path: '/services' },
    { name: 'PRODUCTS', path: '/products' },
    { name: 'SUSTAINABILITY', path: '/sustainability' },
    { name: 'CONTACT', path: '/contact' }
  ];

  // Products页面使用白色背景，其他页面使用透明效果
  const isProductsPage = location.pathname === '/products';
  const headerBg = isProductsPage 
    ? 'bg-white border-b border-gray-200'
    : isScrolled 
      ? 'bg-white/95 backdrop-blur-md border-b border-gray-200' 
      : 'bg-transparent';

  const textColor = isProductsPage || isScrolled ? 'text-gray-900' : 'text-white';
  const mobileButtonColor = isProductsPage || isScrolled ? 'text-gray-900 hover:text-gray-600' : 'text-white hover:text-gray-300';

  // Logo颜色控制：products页面或滚动后使用黑色logo，其他情况使用白色logo
  const logoSrc = isProductsPage || isScrolled
    ? logoImages.main
    : logoImages.white;

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${headerBg}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center">
            <img 
              src={logoSrc}
              alt="Musheng Logo" 
              className={`h-8 w-auto transition-all duration-300 ${
                isProductsPage || isScrolled ? 'brightness-0' : 'brightness-0 invert'
              }`}
            />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex lg:items-center lg:space-x-8">
            <Link 
              to="/" 
              className={`hover:opacity-75 font-light transition-all duration-300 cursor-pointer ${textColor} ${
                location.pathname === '/' 
                  ? 'font-medium' 
                  : ''
              }`}
            >
              HOME
            </Link>
            <Link 
              to="/about" 
              className={`hover:opacity-75 font-light transition-all duration-300 cursor-pointer ${textColor} ${
                location.pathname === '/about' 
                  ? 'font-medium' 
                  : ''
              }`}
            >
              ABOUT US
            </Link>
            <Link 
              to="/services" 
              className={`hover:opacity-75 font-light transition-all duration-300 cursor-pointer ${textColor} ${
                location.pathname === '/services' 
                  ? 'font-medium' 
                  : ''
              }`}
            >
              OUR SERVICES
            </Link>
            <Link 
              to="/products" 
              className={`hover:opacity-75 font-light transition-all duration-300 cursor-pointer ${textColor} ${
                location.pathname === '/products' 
                  ? 'font-medium' 
                  : ''
              }`}
            >
              PRODUCTS
            </Link>
            <Link 
              to="/sustainability" 
              className={`hover:opacity-75 font-light transition-all duration-300 cursor-pointer ${textColor} ${
                location.pathname === '/sustainability' 
                  ? 'font-medium' 
                  : ''
              }`}
            >
              SUSTAINABILITY
            </Link>
            <Link 
              to="/contact" 
              className={`hover:opacity-75 font-light transition-all duration-300 cursor-pointer ${textColor} ${
                location.pathname === '/contact' 
                  ? 'font-medium' 
                  : ''
              }`}
            >
              CONTACT
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className={`lg:hidden transition-all duration-300 cursor-pointer ${mobileButtonColor}`}
          >
            <i className={`text-2xl ${isMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className={`lg:hidden py-6 border-t ${isProductsPage || isScrolled ? 'border-gray-200 bg-white' : 'border-white/20 bg-black/20 backdrop-blur-md'}`}>
            <nav className="flex flex-col space-y-4">
              {navItems.map((item) => (
                <Link
                  key={item.name}
                  to={item.path}
                  className={`block px-3 py-2 font-light cursor-pointer transition-all duration-300 ${textColor} hover:opacity-75 ${
                    location.pathname === item.path 
                      ? 'font-medium'
                      : ''
                  }`}
                  onClick={() => setIsMenuOpen(false)}
                >
                  {item.name}
                </Link>
              ))}
            </nav>
          </div>
        )}
      </div>
    </header>
  );
}
